import { create } from 'zustand';

interface AdaptationPickerState {
  isOpen: boolean;
}

const useAdaptationPickerStore = create<AdaptationPickerState>(() => ({
  isOpen: false,
}));

/** Reactive open state — consumed by the modal. */
export const useAdaptationPickerOpen = (): boolean =>
  useAdaptationPickerStore((state) => state.isOpen);

/** Imperative open — called from the Adaptation tool card. */
export const openAdaptationPicker = (): void => {
  useAdaptationPickerStore.setState({ isOpen: true });
};

/** Imperative close — called when the modal dismisses. */
export const closeAdaptationPicker = (): void => {
  useAdaptationPickerStore.setState({ isOpen: false });
};
